<template>
  <footer class="navbar navbar-default navbar-fixed-bottom">
    <div class="container">
      &nbsp;
      <center>Design &amp; Development by <a href="http://www.dreamstudio.pt" target="_blank">DreamStudio</a> | &copy; {{ ano }} <a href="/">{{ evento }}</a></center>
      &nbsp;
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      ano: new Date().getFullYear(),
      evento: process.env.EVENTO
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Footer.vue?e848f83c